import { useEffect, useState } from 'react';
import styles from './styles.module.css';

import ImageSlider from '../ImageSlider';
// import ZoomImage from '../ZoomImage';
import getFileType from '@/functions/getFileType';
import { media, productCardType, shopServiceType } from '@/commonTypes';
import ProductMedia from '../ProductMedia';
import ZoomImage from '../ZoomImage';

interface ImageGalleryProps {
  className?: string;
  images?: media[];
  data?: productCardType | shopServiceType;
}

const ImageGallery: React.FC<ImageGalleryProps> = ({
  className = 'nothing',
  images = [],
  data,
}) => {
  const [loaded, setLoaded] = useState<boolean>(false);
  const [activeImage, setActiveImage] = useState<media | undefined>(images?.[0]);
  // images?.[0]

  useEffect(() => {
    setActiveImage(images?.[0]);
  }, [images]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoaded(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`${styles.container} ${className}`}>
      {loaded && images.length > 0 && (
        <ImageSlider list={images} activeImage={activeImage} setActiveImage={setActiveImage} />
      )}

      {activeImage ? (
        <>
          {activeImage?.type === 'image' || getFileType(activeImage?.name) === 'image' ? (
            <ZoomImage activeImage={activeImage} data={data} />
          ) : (
            <video
              controls
              src={`${process.env.NEXT_PUBLIC_IMAGE_URL}${activeImage?.name}`}
              style={{ marginBottom: '30px' }}
            />
          )}
        </>
      ) : (
        <ProductMedia
          data={{ ...data, media: images }}
          showImage={false}
          className={`${styles.myClass}`}
        />
      )}
    </div>
  );
};

export default ImageGallery;
